function CategoryPage() {

  return <div> </div>;
}

export default CategoryPage;